import React from 'react';
import cmsComponentRegistry, {
  CmsComponentPropsMap,
  CmsComponentType,
} from './cmsComponentRegistry';

interface GetCmsComponentProps<T extends CmsComponentType> {
  node: CmsComponentPropsMap[T]['node'];
  props?: Omit<CmsComponentPropsMap[T], 'node'>;
}

export function getCmsComponent<T extends CmsComponentType>({
  node,
  props,
}: GetCmsComponentProps<T>): React.ReactElement | null {
  const CmsComponent = cmsComponentRegistry[node.type as T];
  if (CmsComponent) {
    return <CmsComponent node={node} {...(props as any)} />;
  }
  return null;
}
